"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "consortium-page"
  }, [_c("h1", {
    staticClass: "consortium-page__title title-page"
  }, [_vm._v("Consórcio")]), _vm._v(" "), _c("div", [_vm.customersList.length ? _c("div", {
    staticClass: "columns"
  }, [_c("div", {
    staticClass: "column"
  }, [_c("b-table", {
    ref: "multiSortTable",
    attrs: {
      data: _vm.customersList,
      paginated: "",
      "backend-pagination": "",
      total: _vm.total,
      "per-page": _vm.perPage,
      "sort-icon": _vm.sortIcon,
      "sort-icon-size": _vm.sortIconSize,
      loading: _vm.isLoading,
      "pagination-rounded": true,
      "aria-next-label": "Próxima página",
      "aria-previous-label": "Página anterior",
      "aria-page-label": "Página",
      "aria-current-label": "Página atual",
      "row-class": function rowClass() {
        return "consortium-page__row";
      }
    },
    on: {
      "page-change": _vm.onPageChange,
      click: _vm.onRowClick
    }
  }, [[_c("b-table-column", {
    attrs: {
      field: "name",
      label: "Nome",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n                " + _vm._s(props.row.name || "--") + "\n              ")];
      }
    }], null, false, 3469854362)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "service",
      label: "Análise de crédito",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(props.row.creditAnalise ? "Sim" : "Não") + "\n            ")];
      }
    }], null, false, 3278616221)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "service",
      label: "CPF",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(props.row.document) + "\n            ")];
      }
    }], null, false, 4236805298)
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "service",
      label: "Data de solicitação",
      sortable: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm._f("dateBrazil")(props.row.createdAt)) + "\n            ")];
      }
    }], null, false, 2097724523)
  })]], 2)], 1)]) : _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "col-md-12 ml-auto col-xl-12 mr-auto"
  }, [_c("card", [_c("div", {
    staticClass: "content-list"
  }, [_c("h4", {
    staticClass: "text-not-found"
  }, [_vm._v("\n              Não temos usuários registrados no momento.\n            ")])])])], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;